import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { msalInstance } from '@tw/lib';
import './shared/utils/extensions';

async function initializeApp() {
  await msalInstance.initialize();

  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
  );
}

initializeApp();
